module.exports = __webpack_public_path__ + "media/images/fast-1059d356.png";